import React, { useState, useContext, useEffect } from "react"
import ModalViewer from "../components/organisms/modal-viewer/modal-viewer"

export default function useModalContext(__Context) {
  const [modal, setModal] = useState(null)
  const Context = useContext(__Context)
  const { modalActive } = Context

  useEffect(() => {
    setModal(modalActive)
  }, [modalActive])

  return <ModalViewer modal={modal} />
}
